import axios from "axios";

const viewrepetpersonas = () => {
    return axios
        .get(`https://repet.jus.gob.ar/xml/personas.json`);
};

const viewrepetentidadaes = () => {
    return axios
        .get(`https://repet.jus.gob.ar/xml/entidades.json`);
};

const repet = {
    viewrepetpersonas,
    viewrepetentidadaes
};


export default repet;
